// ErrorDisplay component style props
export const domainErrorDisplayContainerStyleProps = {
    width: '100%',
    paddingX: 8,
    paddingY: 6,
    margin: '0 auto',
};

export const errorDisplayCardStyleProps = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: 'white',
    borderRadius: 'md',
    paddingX: 4,
    paddingY: 20,
    gap: 4,
};

// ErrorContentDevSpecific component style props
export const devErrorImageProps = {
    cloudinaryTemplate:
        'https://res.cloudinary.com/spothero/image/upload/$w_{{WIDTH}},$h_{{HEIGHT}},$q_{{QUALITY}}/c_fill,h_$h,q_$q,w_$w/control-panel/car-flat-tire',
    htmlHeight: 200,
    htmlWidth: 200,
    alt: 'Car Flat Tire Icon',
    quality: 100,
};

export const stackTraceContainerStyleProps = {
    direction: 'column',
    gap: 2,
    width: '100%',
    maxWidth: '48rem',
    maxHeight: '24rem',
    background: 'white',
    borderRadius: 'lg',
    borderWidth: 1,
    borderColor: 'gray.medium',
    boxShadow: 'inner',
    padding: 5,
    overflow: 'scroll',
    textAlign: 'left',
};

export const errorCodeStyleProps = {
    as: 'code',
    display: 'inline-block',
    background: 'red.100',
    color: 'red.800',
    borderRadius: 'sm',
    fontFamily: 'monospace',
    paddingX: 1,
    marginBottom: 2,
    width: '100%',
};

// ErrorContentUserSpecific component style props
export const userErrorImageProps = {
    cloudinaryTemplate:
        'https://res.cloudinary.com/spothero/image/upload/$w_{{WIDTH}},$h_{{HEIGHT}},$q_{{QUALITY}}/c_fill,h_$h,q_$q,w_$w/control-panel/detour_illustration',
    htmlHeight: 200,
    htmlWidth: 200,
    alt: 'Detour Icon',
    quality: 100,
};

export const userErrorTextContentStyleProps = {
    direction: 'column',
    justifyContent: 'space-around',
    gap: 8,
    marginTop: 10,
    maxWidth: '48rem',
    textAlign: 'center',
};
